import template from './adpPlainTable.html';
import controller from './adpPlainTable.controller';
import './adpPlainTable.less';

let adpPlainTableComponent = {
  restrict: 'E',
  bindings: {},
  transclude: {
    mainHeader: '?tableMainHeaderSection',
    header: '?tableHeader',
    body: '?tableBody',
  },
  template,
  controller
};

export default adpPlainTableComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpPlainTable/adpPlainTable.component.js